import { Route, Routes } from 'react-router-dom';

import {
  SetDisplayNameScreen,
  SetEmailScreen,
  SetLanguageScreen,
  SetPasswordScreen,
  SetPhoneNumberScreen,
  SetRegionScreen,
  SetUsernameScreen,
} from '../components/Molecules';
import { WebPageType } from '../constants/webPageType';
import AccountScreen from '../screens/AccountSetting/Account';
import AccountInfoScreen from '../screens/AccountSetting/AccountInfo';
import NotFound from '../screens/Auth/NotFound';

interface AccountRouteProps {
  webPageType: WebPageType;
}

const AccountRoute: React.FC<AccountRouteProps> = ({ webPageType }) => {
  return (
    <Routes>
      <Route
        path="/account"
        element={<AccountScreen webPageType={webPageType} />}
      />
      <Route
        path="/account/information"
        element={<AccountInfoScreen webPageType={webPageType} />}
      />
      <Route
        path="/account/display-name"
        element={<SetDisplayNameScreen webPageType={webPageType} />}
      />
      <Route
        path="/account/password"
        element={<SetPasswordScreen webPageType={webPageType} />}
      />
      <Route
        path="/account/email"
        element={<SetEmailScreen webPageType={webPageType} />}
      />
      <Route
        path="/account/phone-number"
        element={<SetPhoneNumberScreen webPageType={webPageType} />}
      />
      <Route
        path="/account/username"
        element={<SetUsernameScreen webPageType={webPageType} />}
      />
      <Route
        path="/account/region"
        element={<SetRegionScreen webPageType={webPageType} />}
      />
      <Route
        path="/account/interface-language"
        element={<SetLanguageScreen webPageType={webPageType} />}
      />
      <Route path="*" element={<NotFound webPageType={webPageType} />} />
    </Routes>
  );
};

export default AccountRoute;
